import { render, staticRenderFns } from "./tradeprice-info.vue?vue&type=template&id=19dc7ea8&"
import script from "./tradeprice-info.vue?vue&type=script&lang=js&"
export * from "./tradeprice-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeprice-info.vue"
export default component.exports